export default [
  {
    _name: "CSidebarNav",
    _children: [
      {
        _name: "CSidebarNavItem",
        name: "داشبورد",
        to: "/dashboard",
        icon: "cil-home",
      },

      // ****************************************************** مدیریت کاربران
      {
        _name: "CSidebarNavTitle",
        _children: ["مدیریت کاربران"],
      },
      {
        _name: "CSidebarNavItem",
        name: "تعریف مراکز",
        to: "/OrganizationStructure",
        icon: "cil-lan",
      },
      {
        _name: "CSidebarNavItem",
        name: "تعریف کاربر",
        to: "/users",
        icon: "cil-user",
      },

      {
        _name: "CSidebarNavItem",
        name: "مدیریت نقش",
        to: "/roles",
        icon: "cil-touch-app",
      },

     
     
      // ****************************************************** مدیریت دستگاه ها
      {
        _name: "CSidebarNavTitle",
        _children: ["مدیریت دستگاه ها"],
      },
      {
        _name: "CSidebarNavItem",
        name: "تعریف دستگاه",
        to: "/Devices",
        icon: "cil-router",
      },
      {
        _name: "CSidebarNavItem",
        name: "تعریف ماموریت",
        to: "/Limits",
        icon: "cil-shield-alt",
      },
      {
        _name: "CSidebarNavItem",
        name: "تعریف فنس",
        to: "/ValidLlimits",
        icon: "cil-shield-alt",
      },

       // ****************************************************** مدیریت لایه ها 
       {
        _name: "CSidebarNavTitle",
        _children: ["مدیریت لایه‌ها"],
      },
      {
        _name: "CSidebarNavItem",
        name: "تعریف لایه",
        to: "/LayerClassify",
        icon: "cil-object-group",
      },
      {
        _name: "CSidebarNavItem",
        name: "تعریف نقاط",
        to: "/LayerPoint",
        icon: "cil-location-pin",
      },

      // ****************************************************** نگهداری و تعمیرات دوره ای  
      {
        _name: "CSidebarNavTitle",
        _children: ["نگهداری و تعمیرات دوره ای"],
      },
      {
        _name: "CSidebarNavItem",
        name: "تعریف سرویس های پایه",
        to: "/BasicServices",
        icon: "cil-cog",
      },
      {
        _name: "CSidebarNavItem",
        name: "برنامه های تعمیر/سرویس",
        to: "/PeriodicServices",
        icon: "cil-aperture",
      },
      {
        _name: "CSidebarNavItem",
        name: "ثبت هزینه",
        to: "/CostPerService",
        icon: "cil-cash",
      },

      // ****************************************************** گزارشات
      {
        _name: "CSidebarNavTitle",
        _children: ["گزارشات"],
      },
      // {
      //   _name: "CSidebarNavItem",
      //   name: "گزارش دستگاه‌/کاربر",
      //   to: "/JointReportTotalUserDevice",
      //   icon: "cil-router",
      // },
      {
        _name: "CSidebarNavItem",
        name: "گزارش",
        to: "/JointReportTotal",
        icon: "cil-router",
      },




    ],
  },
];
